var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c("div", [_c("div", {
    staticClass: "app-container"
  }, [_c("el-descriptions", {
    attrs: {
      size: "mini",
      border: "",
      "label-style": {
        "font-weight": "bold"
      }
    }
  }, [_c("el-descriptions-item", {
    attrs: {
      label: "Dealer ID",
      span: 2
    }
  }, [_vm._v(" " + _vm._s(_vm.data.dealer.id) + " ")]), _c("el-descriptions-item", {
    attrs: {
      label: "Dealer",
      span: 10
    }
  }, [_c("router-link", {
    attrs: {
      to: "/dealers-addresses/list/" + _vm.data.dealer.id
    }
  }, [_c("el-link", {
    attrs: {
      type: "primary"
    }
  }, [_vm._v(" " + _vm._s(_vm.data.dealer.name) + " ")])], 1)], 1), _c("el-descriptions-item", {
    attrs: {
      label: "Dealer City",
      span: 3
    }
  }, [_vm._v(" " + _vm._s(_vm.data.dealer.city) + " ")]), _c("el-descriptions-item", {
    attrs: {
      label: "Fullname"
    }
  }, [_vm._v(" " + _vm._s(_vm.data.dealer.dealersUsers[0].fullName) + " ")]), _c("el-descriptions-item", {
    attrs: {
      label: "Mobile"
    }
  }, [_vm._v(" " + _vm._s(_vm.data.dealer.dealersUsers[0].mobileNumber) + " ")]), _c("el-descriptions-item", {
    attrs: {
      label: "Email"
    }
  }, [_vm._v(" " + _vm._s(_vm.data.dealer.dealersUsers[0].emailAddress) + " ")])], 1)], 1)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };